<div class="doctores-public-container">
    <div class="container">
        <div class="row">
            <div class="col-4">
                <img src="https://api.bealign.com/img/contenidos/18.jpg" class="img-fluid" />
            </div>
            <div class="col-5">
                <div class="row">
                    <div class="col-8 offset-2">
                        <div class="mt-3"  [innerHTML]="combinamos">
                            
                        </div>
                        <div class="mt-3">
                            <a class="btn btn-primary btn-block" [routerLink]="['/acreditacion']">Conviértase en un experto
                                BeAlign</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <img src="https://api.bealign.com/img/contenidos/19.jpg" class="w-75 img-derecha-doctores" />
            </div>
        </div>
    </div>
</div>